<template>
  <div class="modal fade show" id="siteDiaryFormModal" data-bs-backdrop="static" data-bs-keyboard="false"
    data-bs-focus="false" tabindex="-1" role="dialog" aria-labelledby="siteDiaryFormModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content" v-if="show">
        <div class="modal-header shadow-sm">
          <div class="w-100 modal-title font-weight-bold d-flex justify-content-between align-items-center">
            <p class="mb-0">Add Daily Data</p>
            <small class="text-muted">
              {{ Helper.formatDate(currentDate) }}
            </small>
          </div>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label">Scope</label>
            <div class="row row-cols-4">
              <div class="col" v-for="(scope, index) in scopes" :key="`key-scope-${index}`">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="scope" :value="scope" :id="`scope-${index}`"
                    v-model="models.scope" />
                  <label class="form-check-label" :for="`scope-${index}`">
                    {{ scope }}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <label class="form-label">TMP</label>
          <div class="table-responsive">
            <table class="table bg-white table-bordered align-middle">
              <thead>
                <tr>
                  <th class="text-start">Item</th>
                  <th style="width: 7rem">Qty</th>
                  <th style="width: 1%"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, itemIndex) in Object.keys(models.tmps)" :key="`tmp-table-${itemIndex}`">
                  <td class="text-start">{{ item }}</td>
                  <td style="width: 7rem">
                    <input class="form-control" v-model="models.tmps[item]" type="number" min="0" step="1" />
                  </td>
                  <td>
                    <button class="btn btn-link btn-sm text-danger" @click="removeRow('tmps', item)">
                      <i class="fas fa-cancel" />
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2" class="text-center">
                    <button class="btn btn-sm btn-light" @click="addRow('tmps')">
                      Add row
                    </button>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <label class="form-label">Materials</label>
          <div class="table-responsive">
            <table class="table bg-white table-bordered align-middle">
              <thead>
                <tr>
                  <th class="text-start">Item</th>
                  <th style="width: 7rem">Qty</th>
                  <th style="width: 1%"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, itemIndex) in Object.keys(models.materials)" :key="`tmp-table-${itemIndex}`">
                  <td class="text-start">{{ item }}</td>
                  <td style="width: 7rem">
                    <input class="form-control" v-model="models.materials[item]" type="number" min="0" step="1" />
                  </td>
                  <td>
                    <button class="btn btn-link btn-sm text-danger" @click="removeRow('materials', item)">
                      <i class="fas fa-cancel" />
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2" class="text-center">
                    <button class="btn btn-sm btn-light" @click="addRow('materials')">
                      Add row
                    </button>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <label class="form-label">Machineries</label>
          <div class="table-responsive">
            <table class="table bg-white table-bordered align-middle">
              <thead>
                <tr>
                  <th class="text-start">Item</th>
                  <th style="width: 7rem">Qty</th>
                  <th style="width: 1%"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, itemIndex) in Object.keys(models.machineries)" :key="`tmp-table-${itemIndex}`">
                  <td class="text-start">{{ item }}</td>
                  <td style="width: 7rem">
                    <input class="form-control" v-model="models.machineries[item]" type="number" min="0" step="1" />
                  </td>
                  <td>
                    <button class="btn btn-link btn-sm text-danger" @click="removeRow('machineries', item)">
                      <i class="fas fa-cancel" />
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2" class="text-center">
                    <button class="btn btn-sm btn-light" @click="addRow('machineries')">
                      Add row
                    </button>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div class="mb-3">
            <label for="workProgress" class="form-label">
              Work Progress/ Activities/ Findings
            </label>
            <textarea class="form-control" id="workProgress" rows="5" v-model="models.workProgress"></textarea>
          </div>

          <div class="mb-3">
            <label for="workProgress" class="form-label">
              Work Instruction/ Remarks
            </label>
            <textarea class="form-control" id="workInstruction" rows="5" v-model="models.workInstruction"></textarea>
          </div>

          <div class="mb-3">
            <label class="form-label fw-bold mb-0">Weather Conditions</label>
            <p class="form-label text-light">
              F - Fine, C - Cloudy, D - Drizzle, R - Rain
            </p>
            <div class="row row-cols-6">
              <div class="col text-center" v-for="(time, index) in weatherConditions">
                <input type="text" class="form-control text-center" :id="`weatherConditions-${time}`" maxlength="1"
                  v-model="models.weatherConditions[index].condition" @keyup="checkWeatherModel($event, time)" />
                <label class="form-label">
                  {{ time }}
                </label>
              </div>
            </div>
          </div>

          <button class="btn btn-sm btn-info mb-3" @click="showVerificationFields = !showVerificationFields">
            {{ showVerificationFields ? "Hide" : "Show" }}
            Rectification/Verification
          </button>

          <template v-if="showVerificationFields">
            <div class="mb-3">
              <label for="workProgress" class="form-label">
                Method to Corrective/Rectify
              </label>
              <textarea class="form-control" id="methodToCorrective" rows="5"
                v-model="rectificationModels.methodToCorrective"></textarea>
            </div>

            <div class="mb-3">
              <label for="workProgress" class="form-label">
                Rectification of Work
              </label>
              <textarea class="form-control mb-3" id="rectificationOfWork" rows="3"
                v-model="rectificationModels.rectificationOfWork"></textarea>
              <p>Rectification / Progress Image</p>
              <div class="image-grid position-relative" v-if="beforeFilePreview">
                <img :src="beforeFilePreview" />
                <div class="w-100 bg-semi-transparent text-white position-absolute start-0 bottom-0">
                  Before
                </div>
              </div>
              <div class="image-grid image-grid-placeholder" v-else>
                <button class="btn h-100 w-100 fw-bold lh-sm" @click="addImage('before')">
                  <i class="fa-solid fa-plus fa-2x mb-2 d-block" />
                  Add Before Image
                </button>
              </div>
              <div class="image-grid position-relative" v-if="afterFilePreview">
                <img :src="afterFilePreview" />
                <div class="w-100 bg-semi-transparent text-white position-absolute start-0 bottom-0">
                  After
                </div>
              </div>
              <div class="image-grid image-grid-placeholder" v-else>
                <button class="btn h-100 w-100 fw-bold lh-sm" @click="addImage('after')">
                  <i class="fa-solid fa-plus fa-2x mb-2 d-block" />
                  Add After Image
                </button>
              </div>
            </div>

            <div class="mb-3">
              <label for="workProgress" class="form-label">
                Verification of Work
              </label>
              <textarea class="form-control" id="verificationOfWork" rows="5"
                v-model="rectificationModels.verificationOfWork"></textarea>
            </div>
          </template>
        </div>
        <div class="modal-footer shadow">
          <button type="button" class="btn btn-link btn-sm" @click="closeModal()">
            Cancel
          </button>
          <button type="button" class="btn btn-sm btn-primary" @click="saveChanges()" :disabled="isProcessing">
            <div class="spinner-border spinner-border-sm text-light" v-if="isProcessing"></div>
            <span v-else>Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap/dist/js/bootstrap.esm.min";
import MediaViewer from "@/components/MediaViewer";
import Swal from "sweetalert2";

export default {
  name: "site-diary-form-modal",
  props: ["show", "currentDate", "nodData", "getDistrictName", "getRoadName", "currentData"],
  components: { MediaViewer },
  data() {
    return {
      modal: null,
      isProcessing: false,
      showVerificationFields: false,
      scopes: [
        "R01",
        "R02",
        "R03",
        "R04",
        "R05",
        "R06",
        "R07",
        "R08",
        "R09",
        "R10",
        "AK (BP)",
        "AK (BBP)",
      ],
      tmps: [
        "Site Supervisor/Ganger",
        "Flagman",
        "General Workers",
        "Machine Operator",
        "Lorry Driver",
        "Cone",
        "Plastic barrier",
        "Temporary signage",
        "Sub Contractor :- Supervisor",
        "Sub Contractor :- Workers",
        "Others :- Drinking Water",
        "Others :- First Aid Kit",
        "Others :- ",
      ],
      materials: [
        "Hot-mix",
        "Cold-mix",
        "Tack coat",
        "AC14",
        "AC20",
        "AC28",
        "C/Aggregates",
        "Thermo-plastic :- White",
        "Thermo-plastic :- Yellow",
        "Thermo-plastic :- AWT",
        "Others :- ",
      ],
      machineries: [
        "Excavator",
        "Mobile Crane",
        "Backhoe",
        "Concrete Mixer",
        "Generator",
        "Compactor Roller",
        "Dumper Truck :- 6 tonne",
        "Dumper Truck :- 10 tonne",
        "Lorry :- 1 tonne",
        "Lorry :- 3 tonne",
        "Milling Machine",
        "Paver",
        "Tandem Roller",
        "Tyre Roller",
        "CIPR Machine",
        "Hand Compactor",
        "Grass cutter",
        "Hand Sprayer",
        "Others :- Fire Extinguisher 9 kg",
        "Others :- ",
      ],
      weatherConditions: [
        "12 AM",
        "1 AM",
        "2 AM",
        "3 AM",
        "4 AM",
        "5 AM",
        "6 AM",
        "7 AM",
        "8 AM",
        "9 AM",
        "10 AM",
        "11 AM",
        "12 PM",
        "1 PM",
        "2 PM",
        "3 PM",
        "4 PM",
        "5 PM",
        "6 PM",
        "7 PM",
        "8 PM",
        "9 PM",
        "10 PM",
        "11 PM",
      ],
      models: {
        scope: null,
        date: null,
        tmps: {},
        materials: {},
        machineries: {},
        workProgress: null,
        workInstruction: null,
        weatherConditions: [],
      },
      emptyModels: {
        scope: null,
        date: null,
        tmps: {},
        materials: {},
        machineries: {},
        workProgress: null,
        workInstruction: null,
        weatherConditions: [],
      },
      rectificationModels: {
        methodToCorrective: null,
        rectificationOfWork: null,
        verificationOfWork: null,
        statusOfVerification: null,
      },
      emptyRectificationModels: {
        methodToCorrective: null,
        rectificationOfWork: null,
        verificationOfWork: null,
        statusOfVerification: null,
      },
      beforeFileInput: null,
      beforeFilePreview: null,
      afterFileInput: null,
      afterFilePreview: null,
    };
  },
  watch: {
    isProcessing: {
      handler() {
        this.Helper.toggleLoadingSpinner(this.isProcessing);
      },
      deep: true,
      immediate: true,
    },
    show: {
      async handler() {
        if (this.modal && this.show) {
          this.showVerificationFields = false;

          this.models = JSON.parse(JSON.stringify(this.emptyModels));

          this.models.weatherConditions = this.weatherConditions.map((time) => {
            return {
              time: time,
              condition: null,
            };
          });

          this.rectificationModels = JSON.parse(
            JSON.stringify(this.emptyRectificationModels)
          );

          if (this.currentDate) {
            this.models.date = this.currentDate;
          }

          this.beforeFileInput = null;

          this.beforeFilePreview = null;

          this.afterFileInput = null;

          this.afterFilePreview = null;

          if (this.currentData) {
            Object.keys(this.models).forEach(key => {
              this.models[key] = this.currentData[key];
            });
          }

          this.modal.show();
        } else if (this.modal) {
          this.modal.hide();
        }
      },
      immediate: true,
    },
  },
  methods: {
    beforeImageChanged(e) {
      const files = e.target.files;
      if (!files || !files.length) return;

      Object.values(files).forEach((file) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = (readerEvent) => {
          this.beforeFileInput = file;

          this.beforeFilePreview = readerEvent.target.result;
        };
      });

      this.Helper.successToast("Before image added");
    },
    afterImageChanged(e) {
      const files = e.target.files;
      if (!files || !files.length) return;

      Object.values(files).forEach((file) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = (readerEvent) => {
          this.afterFileInput = file;

          this.afterFilePreview = readerEvent.target.result;
        };
      });

      this.Helper.successToast("After image added");
    },
    addImage(type) {
      const input = document.createElement("input");

      input.type = "file";

      input.multiple = false;

      input.accept = "image/*";

      input.onchange =
        type == "before" ? this.beforeImageChanged : this.afterImageChanged;

      input.click();
    },
    removeRow(type, item) {
      const model = JSON.parse(JSON.stringify(this.models[type]));

      delete model[item];

      this.$set(this.models, type, model);
    },
    addRow(type) {
      const inputOptions = {};

      this[type]
        .filter((item) => !Object.keys(this.models[type]).includes(item))
        .forEach((item) => {
          inputOptions[item] = item;
        });

      this.$nextTick(() => {
        Swal.fire({
          html: `<h5 class="mb-1 fw-bold">Select item type</h5><p class="mb-0 text-uppercase text-primary">${type}</p>`,
          input: "select",
          inputOptions: inputOptions,
          inputPlaceholder: "Select an item",
          showCancelButton: true,
          inputValidator: (value) => {
            return new Promise((resolve) => {
              if (!value) {
                resolve("No item selected!");

                return;
              }

              if (value === "Others :-") {
                const othersCount = Object.keys(this.models[type]).filter(
                  (item) => item.startsWith("Others :- ")
                ).length;

                if (othersCount >= 5) {
                  Swal.fire({
                    icon: "warning",
                    html: "<h5 class='fw-bold mb-0'>Only 5 'Others' items can be added</h5>",
                  });
                } else {
                  Swal.fire({
                    html: "<h5 class='fw-bold mb-0'>Enter item name</h5>",
                    input: "text",
                    inputLabel: "Others :-",
                    inputValue: "",
                    showCancelButton: true,
                    inputValidator: (othersValue) => {
                      if (!othersValue) {
                        return "Item name is required";
                      }

                      this.$set(
                        this.models[type],
                        `Others :- ${othersValue}`,
                        1
                      );

                      return;
                    },
                  });
                }
              } else {
                this.$nextTick(() => {
                  this.$set(this.models[type], value, 1);

                  Swal.close();
                });
              }
            });
          },
        });
      });
    },
    checkWeatherModel(e, selectedTime) {
      const weather = this.models.weatherConditions.find(
        (weather) => weather.time == selectedTime
      );

      if (["f", "c", "d", "r"].includes(e.key)) {
        weather.condition = e.key.toUpperCase();
      }

      if (!["F", "C", "D", "R"].includes(weather.condition)) {
        this.$nextTick(() => {
          weather.condition = "";
        });
      }
    },
    formatDate(timestamp) {
      return this.Helper.formatDate(timestamp);
    },
    closeModal(response) {
      if (!this.isProcessing) {
        this.$emit("close", response);
      }
    },
    async saveChanges() {
      Swal.fire({
        icon: "question",
        title: `<h5 class='fw-bold'>${this.currentData ? 'Update' : 'Save'} site diary?</h5>`,
        html: "<p class='mb-0'>This action is not reversible.<br />Data cannot be changed after it is submitted.</p>",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Confirm",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.isProcessing = true;

          let body = {
            nod_case: this.nodData.id,
            road: this.getRoadName(this.nodData.road),
            district: this.getDistrictName(this.nodData.district),
            date: this.models.date,
            scope: this.models.scope,
            tmps: this.models.tmps,
            materials: this.models.materials,
            machineries: this.models.machineries,
            workProgress: this.models.workProgress,
            workInstruction: this.models.workInstruction,
            weatherConditions: this.models.weatherConditions,
            methodToCorrective: this.rectificationModels.methodToCorrective,
            rectificationOfWork: this.rectificationModels.rectificationOfWork,
            verificationOfWork: this.rectificationModels.verificationOfWork,
          };

          const formData = new FormData();

          if (this.beforeFileInput) {
            formData.append(
              "files.rectificationBeforeImage",
              this.beforeFileInput,
              this.beforeFileInput.name
            );
          }

          if (this.afterFileInput) {
            formData.append(
              "files.rectificationAfterImage",
              this.afterFileInput,
              this.afterFileInput.name
            );
          }

          formData.append("data", JSON.stringify(body));

          if (this.currentData) {
            const [call, error] = await this.Helper.handlePromise(
              this.API.putForm("nod-site-diaries", formData)
            );

            if (!error) {
              try {
                const generatePdf = await this.API.get(
                  `nod-site-diaries/generate/${call.data.id}`
                );

                if (generatePdf.data) {
                  call.data.report = generatePdf.data[0];

                  this.isProcessing = false;

                  Swal.fire("Daily data updated", "", "success").then(() => {
                    this.closeModal(call.data);
                  });
                }
              } catch (generateError) {
                this.isProcessing = false;

                Swal.fire(
                  "Error updating site diary",
                  JSON.stringify(generateError.message),
                  "error"
                );
              }
            }
          } else {
            const [call, error] = await this.Helper.handlePromise(
              this.API.postForm("nod-site-diaries", formData)
            );

            if (!error) {
              try {
                const generatePdf = await this.API.get(
                  `nod-site-diaries/generate/${call.data.id}`
                );

                if (generatePdf.data) {
                  call.data.report = generatePdf.data[0];

                  this.isProcessing = false;

                  Swal.fire("Daily data created", "", "success").then(() => {
                    this.closeModal(call.data);
                  });
                }
              } catch (generateError) {
                await this.API.del(`nod-site-diaries/${call.data.id}`);

                this.isProcessing = false;

                Swal.fire(
                  "Error creating site diary",
                  JSON.stringify(generateError.message),
                  "error"
                );
              }
            }
          }
        }
      });
    },
  },
  mounted() {
    this.modal = new Modal(document.getElementById("siteDiaryFormModal"));
  },
};
</script>